export default "__VITE_ASSET__DTx1OcrB__"